module.exports = __webpack_public_path__ + "img/H1.e31acfbd.png";